import { render } from "./AppButtonQuizz.vue?vue&type=template&id=1a9ab001&scoped=true"
import script from "./AppButtonQuizz.vue?vue&type=script&lang=js"
export * from "./AppButtonQuizz.vue?vue&type=script&lang=js"

import "./AppButtonQuizz.vue?vue&type=style&index=0&id=1a9ab001&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9ab001"]])

export default __exports__